<!--智慧城市云峰会-->
<template>
  <div>
    <div class style>
      <ChildrenPage
        :id="3"
        :imgs="[
     require('../assets/imgs/3-0.png'),
    ]"
      />
      <!-- <div class="summary content">
        require('../assets/imgs/3-1.png'),
    require('../assets/imgs/3-2.png'),
    require('../assets/imgs/3-3.png'),
     require('../assets/imgs/3-4.png')
        <h2>会议简介</h2>
        <p>在5G/IoT新时代，工业革新正以科技与创新改变着世界。面对不可预测的挑战，研华期待与各业界伙伴携手，共同为智能未来的建设赋能。 2020年12月17到19日研华智慧城市伙伴峰会，将于线上举行首播，旨在为终端用户、解决方案伙伴及系统集成商提供最新技术和行业新知。透过与核心伙伴卓有成效的紧密合作，推动IoT生态圈的稳健高效发展，洞见IoT美好未来。</p>
      </div>-->
      <!-- <div class="activeity content">
        <h2 class="activeity-title">活动亮点</h2>
      <img src="../assets/imgs/active.png" style="width: 1080px;margin: 0 auto;" alt="">-->
      <!--        <div class="activeityWrap">-->
      <!--          <div class="image-item">-->
      <!--            <img src="../assets/imgs/image-1.jpg" alt />-->
      <!--            <span>AI/5G/loT新技术</span>-->
      <!--          </div>-->
      <!--          <div class="image-item">-->
      <!--            <img src="../assets/imgs/image-2.jpg" alt />-->
      <!--            <span>智能服务/零售/建筑</span>-->
      <!--          </div>-->
      <!--          <div class="image-item">-->
      <!--            <img src="../assets/imgs/image-3.jpg" alt />-->
      <!--            <span>智能移动与物流</span>-->
      <!--          </div>-->
      <!--          <div class="image-item">-->
      <!--            <img src="../assets/imgs/image-4.jpg" alt />-->
      <!--            <span>智能医疗</span>-->
      <!--          </div>-->
      <!--        </div>-->
    </div>
    <div class="activeImg"></div>
    <div class="new content">
      <!-- <h2>最新议程</h2> -->
      <!-- <div class="new-title">12/17(四)</div>
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :icon="activity.icon"
            :type="activity.type"
            :color="activity.color"
            :size="activity.size"
            :timestamp="activity.timestamp"
            placement="top"
          >
            <div>
              <h3>智慧城市伙伴峰会</h3>
              <span>智慧城市伙伴峰会</span>
            </div>
          </el-timeline-item>
      </el-timeline>-->
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import CheckPhone from "../components/checkPhone";
import ChildrenPage from "../components/ChildrenPage";
export default {
  name: "siot",
  components: {
    Header,
    Banner,
    Footer,
    CheckPhone,
    ChildrenPage
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  data() {
    return {
      activities: [
        {
          content: "支持使用图标",
          timestamp: "2018-04-12 20:46",
          type: "primary",
          color: "rgb(232, 149, 21)"
        },
        {
          content: "支持自定义颜色",
          timestamp: "2018-04-03 20:46",
          color: "rgb(232, 149, 21)"
        },
        {
          content: "支持自定义尺寸",
          timestamp: "2018-04-03 20:46",
          color: "rgb(232, 149, 21)"
        },
        {
          content: "默认样式的节点",
          timestamp: "2018-04-03 20:46",
          color: "rgb(232, 149, 21)"
        }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.new {
  /deep/.el-timeline-item__wrapper {
    display: flex;
  }
  /deep/.el-timeline-item__tail {
    position: absolute;
    left: 200px;
  }
  /deep/.el-timeline-item__node--normal {
    left: 195px;
  }
  /deep/.el-timeline-item__timestamp {
    text-align: left;
    flex: 0 0 100px;
  }
  /deep/.el-timeline-item__content {
    text-align: left;
    margin-left: 200px;
    flex: 1;
  }
  /deep/.el-timeline {
    .el-timeline-item {
      &:last-child {
        .el-timeline-item__tail {
          display: block;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
.summary {
  letter-spacing: 1.5px;
  line-height: 30px;
  width: 1080px;
  margin: 0 auto;
  img {
    width: 100%;
    background-color: #f6f7f8;
  }
  p {
    width: 800px;
    font-size: 19px;
    margin: 0 auto 60px;
  }
}
.activeity-title {
  position: absolute;
  font-size: 38px;
  top: 35px;
  left: 50%;
  transform: translateX(-50%);
}
.content {
  //   padding-top: 40px;
}
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.new {
  width: 890px;
  margin: 0 auto;
  text-align: center;
  img {
    width: 100%;
    display: inline-block;
    margin-top: 40px;
    margin-bottom: 80px;
  }
  .new-title {
    border: 1px solid black;
    width: 100px;
    margin-left: 152px;
  }
}
h2 {
  color: rgb(232, 149, 21);
  text-align: center;
  margin-bottom: 40px;
  font-size: 38px;
  letter-spacing: 5px;
}
h3 {
  color: rgb(232, 149, 21);
}
.activeity {
  // width: 1000px;
  position: relative;
  width: 1080px;
  margin: 0 auto 10px;
  // display: flex;
  .activeityWrap {
    display: flex;
    width: 1080px;
    margin: 0 auto;
    text-align: left;
    justify-content: center;
    .image-item {
      /*display: inline-block;*/
      width: 25%;
      text-align: center;
      box-sizing: border-box;
      overflow: hidden;
      :last-child {
        padding-right: 0;
      }
      img {
        display: inline-block;
        border-radius: 0px;
        width: 200px;
        height: 100px;
        position: relative;
        /*transform: skewX(-10deg);*/
        border-right: 3px solid rgb(232, 149, 21);
        margin-right: 10px;
        cursor: pointer;
      }
      span {
        display: block;
        box-sizing: border-box;
        text-align: center;
        font-size: 18px;
        color: #7070c3;
        margin-top: 7px;
      }
    }
  }
}
</style>
